import { useState, useEffect } from "react";
import useProductStore from "../store/productStore";
import useOrderItemsStore from "../store/orderItemsStore";
import plusIcon from "../assets/plusIcon.png";

const EditOrder = ({ items }) => {
  const { products, getAllProducts } = useProductStore();
  const { orderItems, addOrderItem, updateOrderItem, removeOrderItem } =
    useOrderItemsStore();

  const [selectedProduct, setSelectedProduct] = useState("");
  const [quantity, setQuantity] = useState("");
  const [targetValue, setTargetValue] = useState("");
  const [unitValue, setUnitValue] = useState("");

  useEffect(() => {
    try {
      getAllProducts();
    } catch (error) {
      console.error("Erro ao carregar produtos.", error);
    }
  }, [getAllProducts]);

  const handleAddOrderItem = () => {
    if (!selectedProduct || !quantity || !targetValue || !unitValue) {
      alert("Preencha todos os campos antes de adicionar!");
      return;
    }

    if (!products || products.length === 0) {
      console.error("Lista de produtos não carregada.");
      return alert("Erro ao carregar produtos. Tente novamente.");
    }

    const product = products.find((p) => String(p.id) === selectedProduct);

    const newItem = {
      id: product.id,
      name: product.name,
      quantity: parseFloat(quantity),
      target_value: parseFloat(targetValue),
      unit_value: parseFloat(unitValue),
    };

    addOrderItem(newItem);

    // Limpa os campos após adicionar
    setSelectedProduct("");
    setQuantity("");
    setTargetValue("");
    setUnitValue("");
  };

  const handleInputChange = (index, field, value) => {
    const updatedOrder = {
      ...orderItems[index],
      [field]:
        field === "quantity" || field.includes("value")
          ? parseFloat(value) || ""
          : value,
    };
    updateOrderItem(index, updatedOrder);
  };

  return (
    <div className="bg-[#F2F2F2] rounded-md px-4 pb-4 pt-8 mt-4 min-h-[330px] text-boldGray opacity-90">
      <h1 className="text-2xl text-center font-semibold mb-6">
        Edite o seu pedido
      </h1>
      <div className="space-y-4">
        {orderItems.map((orderItem, index) => (
          <div
            key={index}
            className="bg-[#E7E7E7] p-4 rounded-md shadow-md flex flex-wrap gap-4"
          >
            <div className="flex-1">
              <label className="block mb-1 font-semibold">Item</label>
              <select
                value={orderItem.product_id || orderItem.id}
                onChange={(e) =>
                  handleInputChange(index, "product_id", e.target.value)
                }
                className="w-full border rounded p-2"
              >
                <option value="">Selecione um produto</option>
                {products.map((product) => (
                  <option key={product.id} value={product.id}>
                    {product.name}
                  </option>
                ))}
              </select>
            </div>
            <div className="flex-1">
              <label className="block mb-1 font-semibold">Quantidade</label>
              <input
                type="number"
                value={orderItem.quantity || ""}
                onChange={(e) =>
                  handleInputChange(index, "quantity", e.target.value)
                }
                className="w-full border rounded p-2"
              />
            </div>
            <div className="flex-1">
              <label className="block mb-1 font-semibold">Valor alvo</label>
              <input
                type="number"
                step="0.01"
                value={orderItem.target_value || ""}
                onChange={(e) =>
                  handleInputChange(index, "target_value", e.target.value)
                }
                className="w-full border rounded p-2"
              />
            </div>
            <div className="flex-1">
              <label className="block mb-1 font-semibold">Valor unitário</label>
              <input
                type="number"
                step="0.01"
                value={orderItem.unit_value || ""}
                onChange={(e) =>
                  handleInputChange(index, "unit_value", e.target.value)
                }
                className="w-full border rounded p-2"
              />
            </div>
            <div className="flex-1">
              <label className="block mb-1 font-semibold">Total</label>
              <input
                type="text"
                value={(
                  (orderItem.quantity || 0) * (orderItem.target_value || 0)
                ).toFixed(2)}
                readOnly
                className="w-full border rounded p-2 bg-gray-200"
              />
            </div>
            <div className="">
              <button
                onClick={() => removeOrderItem(index)}
                className="bg-red-500 text-white rounded px-4 py-2 mt-6"
                type="button"
              >
                Remover
              </button>
            </div>
          </div>
        ))}
      </div>
      <div className="w-full">
        <div className="h-[20px]"></div>
        <div className="bg-white text-center h-[60px] rounded-md flex flex-wrap md:text-xs xl:text-base">
          <div className="flex-1 py-4 px-2 border-l border-r border-lightGray">
            <select
              id="productSelect"
              value={selectedProduct}
              onChange={(e) => setSelectedProduct(e.target.value)}
            >
              <option value="">Selecione um produto</option>
              {products.map((product) => (
                <option key={product.id} value={product.id}>
                  {product.name}
                </option>
              ))}
            </select>
          </div>
          <div className="flex-1 py-4 px-2 border-l border-r border-lightGray">
            <input
              placeholder="Quantidade"
              type="number"
              className="text-center focus:outline-none w-full"
              value={quantity}
              onChange={(e) => setQuantity(e.target.value)}
            />
          </div>
          <div className="flex-1 py-4 px-2 border-l border-r border-lightGray">
            <input
              placeholder="Valor alvo"
              type="number"
              className="text-center focus:outline-none w-full"
              value={targetValue}
              onChange={(e) => setTargetValue(e.target.value)}
            />
          </div>
          <div className="flex-1 py-4 px-2 border-l border-r border-lightGray">
            <input
              placeholder="Valor unitário"
              type="number"
              className="text-center focus:outline-none w-full"
              value={unitValue}
              onChange={(e) => setUnitValue(e.target.value)}
            />
          </div>
          <div className="flex justify-center items-center py-4 px-2">
            <button
              className="flex justify-center items-center"
              type="button"
              onClick={handleAddOrderItem}
            >
              <img src={plusIcon} alt="Adicionar" />
            </button>
          </div>
          <div className="w-[20px]"></div>
        </div>
      </div>
    </div>
  );
};

export default EditOrder;
